import * as React from "react";
import i18next from "i18next";
import Button from "@material-ui/core/Button";

export default function RefillBalance(props) {
  return (
    <div>
    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 12, fontSize: 18 }}>
      <div style={{ marginRight: 8 }}>
        {i18next.t("balance")}: {props.balance}
      </div>
      <Button variant="contained" onClick={props.moneyAdder} disabled={props.disabled} aria-busy={!!props.busy}>
        {i18next.t("refill")}
      </Button>
      <input
        type="number"
        title={i18next.t("enter_value")}
        aria-label={i18next.t("enter_value")}
        step="0.01"
        min="0.01"
        disabled={props.busy}
        style={{ width: 150, maxWidth: "100%" }}
        value={props.moneyToAdd}
        onChange={(e) => props.stateSetter("add_money", e.target.value)}
      />
    </div>
    {props.error && <div role="alert" style={{ color: "#d32f2f", marginTop: 8 }}>{props.error}</div>}
    </div>
  );
}
